var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.895,
    height: 60.642,
    viewBox: "0 0 49.895 60.642",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20066",
    "data-name": "Group 20066",
    transform: "translate(-2.099 0.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43986",
    "data-name": "Path 43986",
    d: "M24.173,6.229c-.2-4.609-4.76-3.954-6.221-3.047A4.634,4.634,0,0,0,16.34,5.146a3.576,3.576,0,0,0,.781,3.879A4.634,4.634,0,0,0,20.6,10.637a4.206,4.206,0,0,0,3.576-4.407ZM20.395,7.488a1.562,1.562,0,0,1-1.058-.579,1.511,1.511,0,0,1-.529-.68s-.151-.151-.126-.227a2.519,2.519,0,0,1,.554-1.284,1.36,1.36,0,0,1,2.367.856C21.73,6.456,21.3,7.514,20.395,7.488Z",
    transform: "translate(21.223 3.937)",
    fill: "#191919",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43987",
    "data-name": "Path 43987",
    d: "M13,7.836a2.04,2.04,0,0,0,.554-.176c2.267-1.108,2.065-1.385,2.065-1.587,0-1.033-2.367-1.36-2.519-1.385a2.317,2.317,0,0,0-.73,0,2.141,2.141,0,0,0-.655.277C9.571,6.173,9.622,6.6,9.722,7.055,9.8,8.037,12.846,7.836,13,7.836Z",
    transform: "translate(11.52 7.166)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43988",
    "data-name": "Path 43988",
    d: "M9.167,8.959a1.637,1.637,0,0,0,.4-.327c1.612-1.763,1.31-2.04,1.234-2.216-.353-.881-2.72-.3-2.77-.3a2.065,2.065,0,0,0-.63.3,3.047,3.047,0,0,0-.5.479c-1.612,2.116-.982,2.519-.831,2.745C6.6,10.142,9.117,8.984,9.167,8.959Z",
    transform: "translate(5.653 9.091)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43989",
    "data-name": "Path 43989",
    d: "M3.689,14.885c.579.2.856,0,2.267-1.813a4.13,4.13,0,0,0,.353-.554,1.939,1.939,0,0,0,.252-.63c.655-2.519.151-2.72,0-2.846-.705-.428-2.519,1.234-2.519,1.436a2.7,2.7,0,0,0-.4.63,2.8,2.8,0,0,0-.252.73C2.783,14.684,3.463,14.81,3.689,14.885Z",
    transform: "translate(1.586 13.717)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43990",
    "data-name": "Path 43990",
    d: "M5.25,17.114a3.073,3.073,0,0,0,0-.68A2.871,2.871,0,0,0,5.1,15.8c-.881-2.519-1.335-2.342-1.562-2.342-.806,0-1.335,2.116-1.41,2.519a2.7,2.7,0,0,0,0,.781,3.526,3.526,0,0,0,.227.73c1.083,2.67,1.738,2.342,1.964,2.292S5.1,19.682,5.25,17.114Z",
    transform: "translate(0 20.53)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43991",
    "data-name": "Path 43991",
    d: "M6.035,19.549a1.209,1.209,0,0,0-.252-.428c-1.562-1.864-2.015-1.436-2.065-1.436-.806.252-.705,2.519-.705,2.519a1.209,1.209,0,0,0,.176.6,1.939,1.939,0,0,0,.353.529c1.587,1.637,2.141,1.436,2.519,1.209S6.06,19.6,6.035,19.549Z",
    transform: "translate(1.381 26.884)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43992",
    "data-name": "Path 43992",
    d: "M9.178,22.617a4.634,4.634,0,0,0-.957-.781s-2.72-1.385-3.274-.73,1.133,2.821,1.184,2.846a3.425,3.425,0,0,0,.6.6,5.742,5.742,0,0,0,.756.428c2.846,1.259,3.173.453,3.3.2S11.093,24.531,9.178,22.617Z",
    transform: "translate(4.156 31.876)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43993",
    "data-name": "Path 43993",
    d: "M20.362,20.714a3.878,3.878,0,0,0-.428.479,4.307,4.307,0,0,0-.327.579c-.982,2.393-.554,2.519-.378,2.745.68.63,2.745-.932,2.8-.957a2.191,2.191,0,0,0,.479-.579,2.9,2.9,0,0,0,.353-.68c.932-2.67.227-2.871,0-3S22,19.127,20.362,20.714Z",
    transform: "translate(25.639 29.321)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43994",
    "data-name": "Path 43994",
    d: "M22.291,14.381c-.6,0-.831,0-1.562,3.022a5.76,5.76,0,0,1-.176.856,4.86,4.86,0,0,0,0,.856c0,3.173.529,3.073.806,3.148.932.252,1.964-2.116,2.166-2.695a6.8,6.8,0,0,0,.2-.982,4.533,4.533,0,0,0,0-1.007C23.324,14.23,22.594,14.381,22.291,14.381Z",
    transform: "translate(27.991 21.928)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43995",
    "data-name": "Path 43995",
    d: "M23.828,13.492a4.483,4.483,0,0,0-.353-.907c-1.562-3-2.267-2.519-2.519-2.519s-.756.479-.277,3.375a5.516,5.516,0,0,0,.353,1.41s1.385,3.047,2.317,2.77c.3,0,.907-.2.68-3.274A3.047,3.047,0,0,0,23.828,13.492Z",
    transform: "translate(27.915 15.337)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43996",
    "data-name": "Path 43996",
    d: "M15.154,15.858a25.614,25.614,0,0,0,1.461,3.3,23.473,23.473,0,0,0,2.267,3.4,54.676,54.676,0,0,0,4.03,4.332A.831.831,0,1,0,24.1,25.731a43.5,43.5,0,0,1-3.627-4.382,17.227,17.227,0,0,1-1.813-3.173A21.333,21.333,0,0,1,17.5,15.2a22.894,22.894,0,0,1-.655-3.173,15.413,15.413,0,0,1,0-2.191,5.843,5.843,0,0,1,.327-1.889A6.674,6.674,0,0,1,24.8,3.366a6.322,6.322,0,0,1,5.49,6.8,24.657,24.657,0,0,1-1.536,7.556,18.033,18.033,0,0,1-4.181,6.4.935.935,0,1,0,1.284,1.36A20.148,20.148,0,0,0,30.9,18.6a27.7,27.7,0,0,0,2.116-8.16A9.092,9.092,0,0,0,25.455.142,9.571,9.571,0,0,0,14.348,6.716a7.858,7.858,0,0,0-.378,2.342,15.741,15.741,0,0,0,.126,3.274,21.56,21.56,0,0,0,1.058,3.526Z",
    transform: "translate(17.976 0)",
    fill: "#191919",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43997",
    "data-name": "Path 43997",
    d: "M44.184,25.921a25.438,25.438,0,0,0-.252-5.516A14.759,14.759,0,0,0,42.7,16.829a.907.907,0,0,0-1.234-.453.932.932,0,0,0-.453,1.234,12.316,12.316,0,0,1,1.083,3.954,28.686,28.686,0,0,1,0,3.879c-2.519.3-5.037.705-7.556.982h-.554a25.185,25.185,0,0,0-.2-2.77,26.5,26.5,0,0,0-1.234-5.037,37.779,37.779,0,0,0-5.768-10.4.907.907,0,0,0-.705-.327,1.033,1.033,0,0,0,.252-.554.806.806,0,0,0-.781-.856A17.63,17.63,0,0,0,14.868,9,24.984,24.984,0,0,0,7.312,16.88,20.148,20.148,0,0,0,4.567,30,15.464,15.464,0,0,0,11.72,41.612a24,24,0,0,0,21.03,1.234A18.436,18.436,0,0,0,44.184,25.921ZM29.6,19.55a44.932,44.932,0,0,1,1.007,4.634,21.993,21.993,0,0,0,.277,2.519c-2.519.151-4.886,0-7.379,0a38.12,38.12,0,0,1-4.483-.176,5.033,5.033,0,0,1,.176-1.612,45.133,45.133,0,0,1,1.108-5.037c1.234-4.533,4.206-11.862,5.037-10.653A40.473,40.473,0,0,1,29.6,19.55ZM16,10.911a15.59,15.59,0,0,1,7.178-2.519,41.1,41.1,0,0,0-5.793,10.679A31.809,31.809,0,0,0,16,24.486c0,.655,0,1.335,0,2.015h0c-2.9-.227-5.742-.6-8.563-1.058a16.421,16.421,0,0,1,2.04-7.052A22.39,22.39,0,0,1,16,10.911ZM7.438,29.775a17.177,17.177,0,0,1-.176-2.267c2.745.68,5.566,1.234,8.437,1.662v.957a45.561,45.561,0,0,0,1.536,10.7,18.486,18.486,0,0,1-3.954-1.738,12.593,12.593,0,0,1-5.793-9.319Zm11.837,11.56A50.825,50.825,0,0,1,18.52,30.2v-.63c2.015.2,4.03.353,6.045.353s4.282-.176,6.372-.378a44.528,44.528,0,0,1-.73,10.553.957.957,0,0,0,0,.655,20.929,20.929,0,0,1-10.88.579Zm12.971-1.259a42.664,42.664,0,0,0,1.763-11.031l.806-.151c2.317-.5,4.584-1.108,6.9-1.612A15.942,15.942,0,0,1,32.3,40.076Z",
    transform: "translate(3.479 9.833)",
    fill: "#191919",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43998",
    "data-name": "Path 43998",
    d: "M12.991,22.963l-.806-.2a4.635,4.635,0,0,0-.831,0c-3.073,0-3.047.5-3.123.756-.252.907,2.267,2.065,2.519,2.191a3.123,3.123,0,0,0,.957.227,4.282,4.282,0,0,0,1.007-.025c3.3-.277,3.173-1.159,3.173-1.461C15.837,23.693,15.534,23.668,12.991,22.963Z",
    transform: "translate(9.285 34.628)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43999",
    "data-name": "Path 43999",
    d: "M15.88,22.592h-.655a2.519,2.519,0,0,0-.63.2C12.077,23.8,12.3,24.23,12.3,24.456c0,.831,2.216,1.234,2.745,1.284a2.72,2.72,0,0,0,.781,0,3.35,3.35,0,0,0,.756-.277c2.519-1.284,2.242-1.99,2.166-2.216C18.524,22.643,18.171,22.567,15.88,22.592Z",
    transform: "translate(15.488 34.394)",
    fill: "#f15223",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44000",
    "data-name": "Path 44000",
    d: "M19.365,21.893a5.793,5.793,0,0,0-1.133.3s-2.644,1.41-2.519,2.267,2.947.73,3,.73a3.047,3.047,0,0,0,.831-.176,3.1,3.1,0,0,0,.781-.353c2.292-1.41,2.267-2.116,2.015-2.519S22.034,21.415,19.365,21.893Z",
    transform: "translate(20.667 32.977)",
    fill: "#f15223",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.acb341daf01aa913e06ac7d6a4d2c6f2.svg";
export { ForwardRef as ReactComponent };